import { Component, HostListener, Inject, InjectionToken, PLATFORM_ID } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent } from "./shared/components/loader/loader.component";
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'Perspectives';

  constructor(@Inject(PLATFORM_ID) private platformId:InjectionToken<Object>) {}


  ngOnInit(): void {
    if(isPlatformBrowser(this.platformId)) {
      document.addEventListener('contextmenu', event => {
        event.preventDefault();
      });
    }
  }


  private controlKeys = new Set(['Control', 'Meta', 'Shift']);
  private pressedKeys = new Set<string>();

  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.controlKeys.has(event.key)) {
      this.pressedKeys.add(event.key);
      this.applyCanvasBlur();
    }

    // For Windows Print Screen (Screenshot)
    if (event.key === 'PrintScreen' || event.key === 'Snapshot') {
      this.hideContent();
    }
  }
  // @HostListener('window:click')
  // onWindowClick() {
  //   setTimeout(() => {
  //     this.pressedKeys.clear(); // optional: reset pressed keys
  //     this.removeCanvasBlur();
  //   }, 500); // unblur after 1 second
  // }

  @HostListener('window:keyup', ['$event'])
  onKeyUp(event: KeyboardEvent) {
    const key = event.key;
    const code = event.code
    
    if (this.controlKeys.has(event.key)||  // 'Meta', 'Control', 'Shift', 'Super'
    code === 'MetaLeft' || 
    code === 'MetaRight') {
      this.pressedKeys.delete(event.key);
    }

    if (this.pressedKeys.size === 0) {
      this.removeCanvasBlur();
    }
  }

  windowBlurred = false;

  // @HostListener('window:blur')
  // onWindowBlur() {
  //   this.windowBlurred = true;
  //   this.applyCanvasBlur();
  // }

  // @HostListener('window:focus')
  // onWindowFocus() {
  //   this.windowBlurred = false;

  //   // Only remove blur if no keys are pressed
  //   if (this.pressedKeys.size === 0) {
  //     this.removeCanvasBlur();
  //   }
  // }

  private applyCanvasBlur() {
    if(isPlatformBrowser(this.platformId)) 
    document.querySelectorAll('canvas, .canvas').forEach((canvas) => {
      
      (canvas as HTMLCanvasElement).style.filter = 'blur(10px)';
      (canvas as HTMLCanvasElement).style.transition = 'filter 0.3s';
    });
  }

  private removeCanvasBlur() {
    if(isPlatformBrowser(this.platformId)) 
    document.querySelectorAll('canvas, .canvas').forEach(canvas => {
      (canvas as HTMLCanvasElement).style.filter = '';
    });
  }

  private hideContent() {
    // Add any custom logic for hiding content here
    console.log('Hiding sensitive content (PrintScreen detected)');
    if(isPlatformBrowser(this.platformId)) 
    document.querySelectorAll('canvas').forEach(canvas => {
      canvas.style.visibility = 'hidden';
    });

    // Optionally, you can add a timeout to automatically restore visibility
    setTimeout(() => {
    if(isPlatformBrowser(this.platformId)) 
      document.querySelectorAll('canvas').forEach(canvas => {
        canvas.style.visibility = 'visible';
      });
    }, 3000); // Adjust the duration as needed
  }
}
